import {useQuery} from "@tanstack/react-query";
import {useNavigate, useParams} from "react-router-dom";
import Box from "../../components/common/Box";
import API from "@/api";
import RotaForm from "./_components/RotaForm";

const EditRota = () => {
  const navigate = useNavigate();
  const { rota_id } = useParams();

  const theRota = useQuery({
    queryKey: ["rotas", rota_id],
    enabled: rota_id !== null,
    queryFn: () => API.rotas.list().then(res => {
      return res.find(a => a._id === rota_id);
    }),
  });


  const handleUpdateRota = async (data) => {
    return API.rotas.update(rota_id, data).then(() => {
      navigate(`../`)
    });
  };

  return (
    <div className="p-4">
      <Box title="Update Rota">
        {theRota.isSuccess && <RotaForm
          isEdit
          currentValue={theRota.data}
          onSubmit={handleUpdateRota}
          onCancel={() => {
            navigate(`../`)
          }}
        />}
      </Box>
    </div>
  );
};
export default EditRota;